import { render, staticRenderFns } from "./ValidatorIcon.vue?vue&type=template&id=39485d40&scoped=true&"
import script from "./ValidatorIcon.vue?vue&type=script&lang=js&"
export * from "./ValidatorIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39485d40",
  null
  
)

export default component.exports